import { render } from "./procedure.vue?vue&type=template&id=d42e6bfa&scoped=true"
import script from "./procedure.vue?vue&type=script&lang=js"
export * from "./procedure.vue?vue&type=script&lang=js"

import "./procedure.vue?vue&type=style&index=0&id=d42e6bfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d42e6bfa"

export default script